// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_response_markForSalePropertySold(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["ForSalePropertyMarkedSold"]);
}

var variablesConverter = {"markForSalePropertySoldInput":{"soldPrice":{"b":""}},"__root":{"input":{"r":"markForSalePropertySoldInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"markForSalePropertySold_ForSalePropertyMarkedSold_property":{"f":""},"markForSalePropertySold":{"u":"response_markForSalePropertySold"}}};

var wrapResponseConverterMap = {
  response_markForSalePropertySold: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

var responseConverter = {"__root":{"markForSalePropertySold_ForSalePropertyMarkedSold_property":{"f":""},"markForSalePropertySold":{"u":"response_markForSalePropertySold"}}};

var responseConverterMap = {
  response_markForSalePropertySold: unwrap_response_markForSalePropertySold
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

var Utils = {};

var node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "archived",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusChangeComment",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusChangedAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MarkPropertyAsSoldDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "markForSalePropertySold",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ForSalePropertyV5",
                "kind": "LinkedField",
                "name": "property",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SellerPropertyStatusCallout_forSalePropertyV5"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ClientPageMatchingStatusLabel_matchable"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "ForSalePropertyMarkedSold",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MarkPropertyAsSoldDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "markForSalePropertySold",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ForSalePropertyV5",
                "kind": "LinkedField",
                "name": "property",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "status",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isRenewable",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "activeUntil",
                            "storageKey": null
                          }
                        ],
                        "type": "ActiveProperty",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "expiredAt",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "type": "ExpiredProperty",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "withdrawnAt",
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          (v3/*: any*/)
                        ],
                        "type": "WithdrawnProperty",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/),
                          (v3/*: any*/),
                          (v5/*: any*/)
                        ],
                        "type": "UnderContractProperty",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "soldPrice",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Price",
                                    "kind": "LinkedField",
                                    "name": "price",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "formatted",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "visibility",
                                    "storageKey": null
                                  }
                                ],
                                "type": "VisibleSoldPrice",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "type": "SoldProperty",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "activelyMatching",
                        "storageKey": null
                      }
                    ],
                    "type": "Matchable",
                    "abstractKey": "__isMatchable"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "ForSalePropertyMarkedSold",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "352898acb724126cafe1e7827b8da01d",
    "id": null,
    "metadata": {},
    "name": "MarkPropertyAsSoldDialogMutation",
    "operationKind": "mutation",
    "text": "mutation MarkPropertyAsSoldDialogMutation(\n  $input: MarkForSalePropertySoldInput!\n) {\n  markForSalePropertySold(input: $input) {\n    __typename\n    ... on ForSalePropertyMarkedSold {\n      property {\n        ...SellerPropertyStatusCallout_forSalePropertyV5\n        ...ClientPageMatchingStatusLabel_matchable\n        nodeId\n      }\n    }\n  }\n}\n\nfragment ClientPageMatchingStatusLabel_matchable on Matchable {\n  __isMatchable: __typename\n  __typename\n  activelyMatching\n}\n\nfragment ExpiredForSalePropertyCallout_expiredProperty on ExpiredProperty {\n  expiredAt\n  archived\n}\n\nfragment ExpiringForSalePropertyCallout_activeProperty on ActiveProperty {\n  activeUntil\n}\n\nfragment SellerPropertyStatusCallout_forSalePropertyV5 on ForSalePropertyV5 {\n  id\n  nodeId\n  status {\n    __typename\n    ... on ActiveProperty {\n      isRenewable\n      ...ExpiringForSalePropertyCallout_activeProperty\n    }\n    ... on ExpiredProperty {\n      ...ExpiredForSalePropertyCallout_expiredProperty\n    }\n    ... on WithdrawnProperty {\n      ...WithdrawnPropertyCallout_withdrawnProperty\n    }\n    ... on UnderContractProperty {\n      ...UnderContractPropertyCallout_underContractProperty\n    }\n    ... on SoldProperty {\n      ...SoldPropertyCallout_soldProperty\n    }\n  }\n}\n\nfragment SoldPropertyCallout_soldProperty on SoldProperty {\n  statusChangeComment\n  statusChangedAt\n  soldPrice {\n    __typename\n    ... on VisibleSoldPrice {\n      price {\n        formatted\n      }\n      visibility\n    }\n  }\n  archived\n}\n\nfragment UnderContractPropertyCallout_underContractProperty on UnderContractProperty {\n  statusChangeComment\n  archived\n  statusChangedAt\n}\n\nfragment WithdrawnPropertyCallout_withdrawnProperty on WithdrawnProperty {\n  withdrawnAt\n  statusChangeComment\n  archived\n}\n"
  }
};
})());

var wrap_response_markForSalePropertySold = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_markForSalePropertySold = unwrap_response_markForSalePropertySold;
exports.wrap_response_markForSalePropertySold = wrap_response_markForSalePropertySold;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
